import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useIntl } from 'react-intl';

import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import { useIntlWrapperContext } from '../../Helpers/IntlWrapperProvider';

import { 
	UpgradeRequestResponse,
	UpgradeRequestModel,
	UserProfileModel,
	UserProfileResponse,
} from "./BackofficeUpgradeRequest.model";

const useUpgradeRequest = (props: any) => {
	const [ upgradeRequest, setUpgradeRequest ] = useState<UpgradeRequestModel>();
	const [ userProfile, setUserProfile] = useState<UserProfileModel>();
	const [ loading, setLoading ] = useState(true);

	const { get, put } = useFetchWrapper();
	const { requestId } = props;

	const history = useHistory();
	const intl = useIntl();
	const { getI18nCountryName, getI18nLanguageName } = useIntlWrapperContext();
	
	useEffect(() => {
		getUpgradeRequest(requestId);
	},[])
	
	const getUpgradeRequest = async(requestId: string) => {
		const response: HttpResponse<UpgradeRequestResponse> = await get(`/user/upgrade-role/${requestId}`);

		if (response.parsedBody) {
			const { requestUpgradeRole } = response.parsedBody;
			
			const {
				createdAt,
				introduction,
				mentoringScopes,
				status,
				userId,
			} = requestUpgradeRole;

			setUpgradeRequest({
				createdAt,
				introduction,
				mentoringScopes: mentoringScopes?.map(item => intl.formatMessage({ id: `mentoringScopes.${item}` })),
				status,
				userId,
			});

			const responseUserProfile: HttpResponse<UserProfileResponse> = await get(`/user/profile/${userId}`);

			if (responseUserProfile.parsedBody) {
				const {
					currentPosition,
					education,
					email,
					firstName,
					imageId,
					languages,
					lastName,
					location,
					researchAreas,
					role,
					workExperience,
				} = responseUserProfile.parsedBody;

				setUserProfile({
					currentPosition: currentPosition ? intl.formatMessage({ id: `currentPosition.${currentPosition}`}) : '',
					education,
					email,
					imageId,
					institution: workExperience[0],
					languages: languages?.map((code) => getI18nLanguageName(code)),
					location: location ? getI18nCountryName(location) : '',
					name: `${firstName} ${lastName} `,
					researchAreas,
					role: role,
					workExperience: workExperience,
				});
			}
		}
		
		setLoading(false);
	}

	const onApproveRequest = async () => {
		const response = await put(`/user/upgrade-role/${requestId}/approve`, {});
		if (response.ok) {
			history.push("/upgrade-request");
		}

	}
	const onRejectRequest = async () => {
		const response = await put(`/user/upgrade-role/${requestId}/reject`, {});
		if (response.ok) {
			history.push("/upgrade-request");
		}
	}

	return {
		onApproveRequest,
		onRejectRequest,
		state: {
			loading,
			upgradeRequest,
			userProfile,
		},
	}
}

export default useUpgradeRequest;